"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.containerStyle = exports.childContainerStyle = exports.getDividerStyle = exports.DASHED = exports.SOLID = void 0;
var react_1 = require("@emotion/react");
exports.SOLID = 'solid';
exports.DASHED = 'dashed';
var getDividerStyle = function (size, type, color, direction) {
    var _a;
    return react_1.css((_a = {},
        _a[direction === 'horizontal' ? 'borderBottom' : 'borderLeft'] = size + "px " + type + " " + color,
        _a[direction === 'horizontal' ? 'width' : 'height'] = '100%',
        _a));
};
exports.getDividerStyle = getDividerStyle;
exports.childContainerStyle = react_1.css({ padding: '0 8px' });
var containerStyle = function (direction) {
    var _a;
    return react_1.css((_a = {},
        _a[direction === 'horizontal' ? 'width' : 'height'] = '100%',
        _a.display = 'flex',
        _a.justifyContent = 'center',
        _a.alignItems = 'center',
        _a.flexDirection = direction === 'horizontal' ? 'row' : 'column',
        _a));
};
exports.containerStyle = containerStyle;
